import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonavimumaiairportcab() {



  const cardData = {


  keyword: "Pune to Navi Mumbai Airport Cab",

  headingDescription: "Trustline Cab provides reliable Pune to Navi Mumbai Airport cab services with comfortable, safe, and affordable transportation for domestic and international travelers. Whether you're traveling for a business trip, family vacation, corporate transfer, or catching a flight, our experienced chauffeurs ensure timely pickups and a smooth, hassle-free journey. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, flight-friendly scheduling, easy online booking, and 24/7 customer support, Trustline Travels is the trusted choice for Pune to Navi Mumbai Airport taxi services.",

 topPlaces: [
  {
    title: "Navi Mumbai International Airport",
    description: "Navi Mumbai International Airport is a modern aviation hub serving domestic and international passengers with advanced terminals, efficient facilities, and excellent regional connectivity."
  },
  {
    title: "Airport Terminal",
    description: "The terminal at Navi Mumbai International Airport provides modern check-in counters, security facilities, boarding areas, lounges, dining, shopping, and passenger services."
  },
  {
    title: "Navi Mumbai Airport Arrivals",
    description: "The arrivals area provides baggage collection, passenger assistance, immigration, customs, and convenient transportation facilities for arriving travelers."
  },
  {
    title: "Navi Mumbai Airport Departures",
    description: "The departures area offers check-in facilities, security screening, boarding gates, lounges, dining options, and essential services for departing passengers."
  },
  {
    title: "Navi Mumbai Airport Parking",
    description: "Navi Mumbai International Airport provides dedicated parking facilities for passengers and visitors, offering convenient vehicle parking near the terminal."
  },
  {
    title: "Navi Mumbai Airport Lounges",
    description: "Airport lounges provide comfortable seating, refreshments, Wi-Fi, business facilities, and premium services for passengers waiting for their flights."
  },
  {
    title: "Navi Mumbai Airport Duty Free",
    description: "The airport's duty-free shopping facilities offer travelers a selection of international products, cosmetics, gifts, luxury items, and travel essentials."
  },
  {
    title: "Navi Mumbai Airport Check-in",
    description: "The airport check-in area provides airline counters and modern self-service facilities to help passengers complete check-in and baggage procedures efficiently."
  },
  {
    title: "Navi Mumbai Airport Baggage Services",
    description: "Dedicated baggage facilities support passengers with baggage collection, handling, assistance, and other essential services during their airport journey."
  },
  {
    title: "Navi Mumbai Airport Transport",
    description: "Navi Mumbai International Airport offers convenient transportation connections, helping passengers access taxis, buses, private vehicles, and other local travel options."
  }
],






"services": [
  {
    "name": "Pune to Navi Mumbai Airport Cab",
    "description": "Book Pune to Navi Mumbai Airport cab with safe, comfortable, and affordable AC vehicles for airport transfers, one-way trips, round trips, business travel, and family journeys with professional drivers."
  },
  {
    "name": "Pune to Navi Mumbai Airport Taxi",
    "description": "Hire Pune to Navi Mumbai Airport taxi with experienced chauffeurs, transparent pricing, clean vehicles, and on-time airport transfers."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Service",
    "description": "Choose Pune to Navi Mumbai Airport cab service for reliable airport transportation with Sedan, Ertiga, Innova Crysta, SUV, and premium cars."
  },
  {
    "name": "Pune to Navi Mumbai Airport Taxi Service",
    "description": "Travel comfortably with Pune to Navi Mumbai Airport taxi service offering punctual pickup, affordable fares, and 24x7 customer support."
  },
  {
    "name": "Pune to Navi Mumbai Airport Transfer",
    "description": "Book Pune to Navi Mumbai Airport transfer with professional drivers, luggage assistance, and comfortable long-distance travel."
  },
  {
    "name": "Pune to Navi Mumbai Airport Drop",
    "description": "Reserve Pune to Navi Mumbai Airport drop service for timely airport arrivals with reliable chauffeur-driven vehicles."
  },
  {
    "name": "Pune to Navi Mumbai Airport Pickup",
    "description": "Book Pune to Navi Mumbai Airport pickup service with flight tracking, professional drivers, and hassle-free airport transfers."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Booking",
    "description": "Complete your Pune to Navi Mumbai Airport cab booking online with instant confirmation and transparent pricing."
  },
  {
    "name": "Online Pune to Navi Mumbai Airport Cab",
    "description": "Book online Pune to Navi Mumbai Airport cab with quick reservations, multiple vehicle options, and secure booking."
  },
  {
    "name": "Book Pune to Navi Mumbai Airport Cab",
    "description": "Reserve Pune to Navi Mumbai Airport cab with doorstep pickup, experienced chauffeurs, and comfortable AC vehicles."
  },
  {
    "name": "Pune to NMIA Cab",
    "description": "Hire Pune to NMIA cab for convenient airport transfers with affordable fares and professional drivers."
  },
  {
    "name": "Pune to Navi Mumbai International Airport Cab",
    "description": "Choose Pune to Navi Mumbai International Airport cab service for reliable airport travel with Sedan, Ertiga, Innova Crysta, and SUV options."
  },
  {
    "name": "Pune to Navi Mumbai Airport Taxi Booking",
    "description": "Book Pune to Navi Mumbai Airport taxi online with fixed fares, instant confirmation, and 24x7 support."
  },
  {
    "name": "Pune to Navi Mumbai Airport Car Rental",
    "description": "Hire chauffeur-driven Pune to Navi Mumbai Airport car rental with flexible travel options for business and family trips."
  },
  {
    "name": "Pune to Navi Mumbai Airport Travel",
    "description": "Enjoy comfortable Pune to Navi Mumbai Airport travel with clean vehicles, experienced drivers, and reliable service."
  },
  {
    "name": "Pune to NMIA Taxi",
    "description": "Book Pune to NMIA taxi for safe, affordable, and punctual airport transportation."
  },
  {
    "name": "Pune to Navi Mumbai Airport One Way Cab",
    "description": "Choose Pune to Navi Mumbai Airport one way cab and pay only for your single journey with no return charges."
  },
  {
    "name": "Pune to Navi Mumbai Airport Round Trip Cab",
    "description": "Book Pune to Navi Mumbai Airport round trip cab with flexible waiting options and affordable return packages."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Fare",
    "description": "Check Pune to Navi Mumbai Airport cab fare with transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Pune to Navi Mumbai Airport Taxi Fare",
    "description": "Get the latest Pune to Navi Mumbai Airport taxi fare with fixed pricing and no hidden charges."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Price",
    "description": "Compare Pune to Navi Mumbai Airport cab price across multiple vehicle categories with affordable rates."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Charges",
    "description": "Know Pune to Navi Mumbai Airport cab charges with transparent billing and fixed fare options."
  },
  {
    "name": "Pune to Navi Mumbai Airport Taxi Cost",
    "description": "Estimate Pune to Navi Mumbai Airport taxi cost for one-way, round-trip, and airport transfer services."
  },
  {
    "name": "Affordable Pune to Navi Mumbai Airport Cab",
    "description": "Book affordable Pune to Navi Mumbai Airport cab with budget-friendly fares, clean vehicles, and reliable drivers."
  },
  {
    "name": "Cheap Pune to Navi Mumbai Airport Cab",
    "description": "Hire cheap Pune to Navi Mumbai Airport cab without compromising on comfort, safety, or service quality."
  },
  {
    "name": "Lowest Fare Pune to Navi Mumbai Airport Cab",
    "description": "Get the lowest fare Pune to Navi Mumbai Airport cab with transparent pricing and dependable airport taxi service."
  },
  {
    "name": "Fixed Fare Pune to Navi Mumbai Airport Cab",
    "description": "Choose fixed fare Pune to Navi Mumbai Airport cab with no surge pricing and complete fare transparency."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Per Km",
    "description": "Check Pune to Navi Mumbai Airport cab per km rates for Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles."
  }
],

"tableData": [
  ["Pune to Navi Mumbai Airport Cab", "Pune to Navi Mumbai Airport Taxi"],
  ["Pune to Navi Mumbai Airport Cab Service", "Pune to Navi Mumbai Airport Taxi Service"],
  ["Pune to Navi Mumbai Airport Transfer", "Pune to Navi Mumbai Airport Drop"],
  ["Pune to Navi Mumbai Airport Pickup", "Pune to Navi Mumbai Airport Cab Booking"],
  ["Online Pune to Navi Mumbai Airport Cab", "Book Pune to Navi Mumbai Airport Cab"],
  ["Pune to NMIA Cab", "Pune to Navi Mumbai International Airport Cab"],
  ["Pune to Navi Mumbai Airport Taxi Booking", "Pune to Navi Mumbai Airport Car Rental"],
  ["Pune to Navi Mumbai Airport Travel", "Pune to NMIA Taxi"],
  ["Pune to Navi Mumbai Airport One Way Cab", "Pune to Navi Mumbai Airport Round Trip Cab"],
  ["Pune to Navi Mumbai Airport Cab Fare", "Pune to Navi Mumbai Airport Taxi Fare"],
  ["Pune to Navi Mumbai Airport Cab Price", "Pune to Navi Mumbai Airport Cab Charges"],
  ["Pune to Navi Mumbai Airport Taxi Cost", "Affordable Pune to Navi Mumbai Airport Cab"],
  ["Cheap Pune to Navi Mumbai Airport Cab", "Lowest Fare Pune to Navi Mumbai Airport Cab"],
  ["Fixed Fare Pune to Navi Mumbai Airport Cab", "Pune to Navi Mumbai Airport Cab Per Km"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Pune to Navi Mumbai Airport Cab Service",
    WhyChoosedescription: "Trustline Cab offers dependable cab services from Pune to Navi Mumbai International Airport with timely pickups and comfortable long-distance travel."
  },
  {
    WhyChooseheading: "On-Time Airport Transfers",
    WhyChoosedescription: "Our drivers prioritize punctuality to ensure you reach Navi Mumbai Airport well before your flight departure."
  },
  {
    WhyChooseheading: "Professional & Experienced Chauffeurs",
    WhyChoosedescription: "Travel safely with trained drivers who are familiar with expressway routes and airport drop procedures."
  },
  {
    WhyChooseheading: "Affordable Airport Cab Fares",
    WhyChoosedescription: "Get competitive pricing with transparent fare quotations and no hidden charges for your airport transfer."
  },
  {
    WhyChooseheading: "Comfortable Vehicle Selection",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your passengers and luggage requirements."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Book airport cabs any time of the day or night for early morning, late-night, or scheduled flight departures."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide pickup from homes, hotels, offices, Pune Railway Station, Pune Airport, and all major areas across Pune."
  },
  {
    WhyChooseheading: "Instant Booking Confirmation",
    WhyChoosedescription: "Receive quick fare estimates, immediate booking confirmation, and dedicated customer support for a hassle-free airport transfer."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Navi Mumbai Airport cab service?",
    answer: "Yes, Trustline Cab offers reliable cab services from Pune to Navi Mumbai International Airport for individuals, families, and corporate travelers."
  },
  {
    question: "Can I book a one-way cab to Navi Mumbai Airport?",
    answer: "Yes, we provide affordable one-way airport cab services from Pune to Navi Mumbai International Airport."
  },
  {
    question: "Which vehicles are available for airport transfers?",
    answer: "Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to accommodate different passenger and luggage requirements."
  },
  {
    question: "Do you provide doorstep pickup in Pune?",
    answer: "Yes, we offer pickup from homes, hotels, offices, Pune Railway Station, Pune Airport, and all major locations across Pune."
  },
  {
    question: "How early should I book my airport cab?",
    answer: "Advance booking is recommended to ensure vehicle availability and timely pickup based on your flight schedule."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in your quotation."
  },
  {
    question: "Is Pune to Navi Mumbai Airport cab service available 24/7?",
    answer: "Yes, Trustline Cab provides airport cab services round the clock for all flight timings."
  },
  {
    question: "Can I schedule my return journey as well?",
    answer: "Yes, you can book both one-way and round-trip airport transfer services according to your travel plans."
  },
  {
    question: "Do you provide airport cabs for corporate travelers?",
    answer: "Yes, our airport transfer services are ideal for business executives, corporate employees, and frequent flyers."
  },
  {
    question: "How can I book a Pune to Navi Mumbai Airport cab with Trustline Travels?",
    answer: "Simply share your pickup location, flight timing, travel date, passenger count, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket Joshi",
    feedback: "I booked a cab from Pune to Navi Mumbai Airport with Trustline Travels for an early morning flight. The driver arrived before time, the vehicle was clean, and the journey was smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Patwardhan",
    feedback: "Trustline Travels provided an excellent airport transfer from Pune to Navi Mumbai International Airport. The booking process was quick, the fare was transparent, and we reached the airport comfortably on schedule.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Navi Mumbai Airport Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-navi-mumbai-airport-cab.webp",
  "description": "Book Pune to Navi Mumbai Airport cab service with Trustline Travels for safe, comfortable, and affordable airport transfers. Get one-way, round-trip, and airport drop taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5872"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-navi-mumbai-airport-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Pune to Navi Mumbai Airport Cab | Airport Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Navi Mumbai Airport cab service with Trustline Travels for reliable airport transfers. Choose affordable Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis for one-way and round-trip journeys available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to Navi Mumbai Airport Cab, Pune to Navi Mumbai Airport Taxi, Pune to Navi Mumbai Airport Cab Service, Pune to Navi Mumbai Airport Taxi Service, Pune to Navi Mumbai Airport Transfer, Pune to Navi Mumbai Airport Drop, Pune to Navi Mumbai Airport One Way Cab, Pune to Navi Mumbai Airport Taxi Booking, Pune Navi Mumbai Airport Cab, Pune to Navi Mumbai Airport Innova Cab, Pune Airport to Navi Mumbai Airport Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/64.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonavimumaiairportcab;